import {CountUp} from "countup.js";
import {connect} from "../../../JavaScript/Utils";

class Counter {
  /** @param {HTMLElement} element */
  constructor(element) {
    const digitelement = element.querySelector('.profinet-counter-digit');
    (new CountUp(digitelement, Number.parseFloat(digitelement.innerText), digitelement.dataset)).start();
  }
}

connect('.profinet-counter', Counter)
